import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateMustBeBeforeOrEqualThanToday(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const date = control.value as Date;

    if (!date) {
      return null;
      // return {
      //   description: 'No value provided',
      //   code: '400',
      // };
    }

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    if (date > currentDate) {
      return {
        description: 'No puedes ingresar una fecha posterior a la fecha actual. Por favor intenta con otra.',
        code: '300',
      };
    }

    return null;
  };
}
